import { AxiosResponse } from "axios";

export interface Page<T> {
  data: T[];
  meta: PageMeta;
  links: PageLinks;
}

export interface PageMeta {
  page: number;
  site: number;
  totalElements: number;
  nextPage: number | null;
}

export interface PageLinks {
  self: string;
  first: string;
  prev?: string;
  next?: string;
  last: string;
}

export async function compileAllPages<T>(
  pageFunction: (pageNumber: number) => Promise<AxiosResponse<Page<T>>>
): Promise<T[]> {
  const list: T[] = [];

  let nextPage: number | null = 0;
  const setNextPage = (value: number | null) => {
    nextPage = value;
  };

  while (nextPage !== null) {
    await pageFunction(nextPage)
      .then((res) => res.data)
      .then(({ meta, data }) => {
        setNextPage(meta.nextPage);
        list.push(...data);
      });
  }

  return list;
}
